import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Filterbox } from '../filterbox.service';


@Component({
  selector: 'filterbox-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./filterbox.component.css'],
  providers: [ Filterbox ]
})
@Injectable({
  providedIn: 'root'
})
export class ProgramComponent {
  private programsList = [];


  constructor(private filterboxService : Filterbox) {
    filterboxService.getPrograms().then((data) => {
      this.programsList = data;
    });
  }


}
